/* import __COLOCATED_TEMPLATE__ from './inbox-canvas.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();